import useGlobalStateStore from "@/app/(index)/use-global-state-store";
import styles from './index.module.css'
import cx from "clsx";
import {UnstyledButton} from "@mantine/core";
import React from "react";

interface IProps {
    name?: string;
    name_c?: string;
    name_e?: string;
    name_c_lv2?: string;
    name_e_lv2?: string;
    lv1Link?: string,
}

const Bread: React.FC<IProps> = ( { name_c, name, name_e } ) => {
    const {fontSize, lang} = useGlobalStateStore();

    return (
        <div className={cx(styles.breadContainer)}>
            <div className={cx(styles.breadBG, "flex gap-3 items-center w-[1250px] mx-auto")}>
                <UnstyledButton component="a" href="/">
                    <div className="text-[#158a83] text-[16px]">
                        {lang == "tw" ? "首頁" : "Home"}
                    </div>
                </UnstyledButton>
                <div className="text-[16px] text-[#c4c4c4]">&gt;</div>
                <div className="text-[16px] text-[#232222]">
                    {lang == "tw" ? name_c??name : name_e}
                </div>
            </div>
        </div>
    )
}



export const BreadLv3: React.FC<IProps> = ( { name_c, name_e, name_e_lv2, name_c_lv2, lv1Link } ) => {
    const {fontSize, lang} = useGlobalStateStore();

    return (
        <div className={cx(styles.breadContainer)}>
            <div className={cx(styles.breadBG, "flex gap-3 items-center w-[1250px] mx-auto")}>
                <UnstyledButton component="a" href="/">
                    <div className="text-[#158a83] text-[16px]">
                        {lang == "tw" ? "首頁" : "Home"}
                    </div>
                </UnstyledButton>
                <div className="text-[16px] text-[#c4c4c4]">&gt;</div>
                <UnstyledButton component="a" href={lv1Link}>
                    <div className="text-[#158a83] text-[16px]">
                        {lang == "tw" ? name_c : name_e }
                    </div>
                </UnstyledButton>
                <div className="text-[16px] text-[#c4c4c4]">&gt;</div>
                <div className="text-[16px] text-[#232222]">
                    {lang == "tw" ? name_c_lv2 : name_e_lv2 }
                </div>
            </div>
        </div>
    )
}

export default Bread;